import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getGeofencesList } from '../../services/GeofencesService';
import { GeofencesResponse } from '../../types/Geofences';

function useGetGeofencesList(fleetId: string): UseQueryResult<GeofencesResponse> {
  return useQuery(
    ['geofences', fleetId],
    async (): Promise<GeofencesResponse> => getGeofencesList(fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetGeofencesList;
